require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-rosetta-code-count-occurrences-of-a-substring.json") })
        }
      }, "path---coding-interview-prep-rosetta-code-count-occurrences-of-a-substring");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-rosetta-code-count-occurrences-of-a-substring!./.cache/json/coding-interview-prep-rosetta-code-count-occurrences-of-a-substring.json
// module id = 1849
// module chunks = 231608221292675